import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ShopService {

  constructor(private db: AngularFirestore, private storage: AngularFireStorage, private http: HttpClient) { }

  getOverviews(): Observable<any> {
    return this.db.collection('overviews').doc('main').get()
      .pipe(map(item => {
        return {
          shops: item.data().shops,
          businessSectors: item.data().businessSectors
        }
      }));
  }

  getShop(shopId: string): Observable<any> {
    return this.db.collection('shops').doc(shopId).get()
      .pipe(map(item => item.data()));
  }

  async getShopPictures(shopId: string): Promise<string[]> {
    try {
      const pictures: string[] = [];
      const files = await this.storage.storage.ref(`shops/${shopId}/`).listAll();
      const fileUrls = files.items.map(file => file.getDownloadURL());
      await Promise.all(fileUrls);
      for (const fileUrl of fileUrls) {
        pictures.push(await fileUrl);
      }
      return pictures;
    } catch (err) {
      console.log('Unable to load shop pictures');
      return [];
    }
  }

  getMarket(marketId: string): Observable<any> {
    return this.http.get('assets/markets.json').pipe(map(item => item[marketId]));
  }

  getMarketActivities(): Observable<any> {
    return this.http.get('assets/market-activities.json');
  }
}
